import * as Yup from 'yup';

export default Yup.object({
  Title: Yup.string().required('Privaloma įvesti pavadinimą'),
  Coordinates: Yup.object().typeError('Privaloma pasirinkti objekto lokaciją'),
});
